import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiClock,FiBriefcase,FiTarget,FiTrendingUp,FiShield,FiBookOpen}=FiIcons;

const Benefits=()=> {
  const benefits=[
    {
      icon: FiClock,
      title: "Time-Efficient Learning",
      description: "15-minute focused lessons that fit your busy schedule. No 3-hour rambling tutorials.",
      highlight: "Save 15+ hours weekly"
    },
    {
      icon: FiBriefcase,
      title: "Work-Ready Skills",
      description: "Learn AI tools you'll actually use in your job, not theoretical concepts you'll never apply.",
      highlight: "Immediate workplace impact"
    },
    {
      icon: FiTarget,
      title: "Gen X Focused",
      description: "Training designed for your learning style - direct, practical, and respectful of your experience.",
      highlight: "Built for professionals 45+"
    },
    {
      icon: FiTrendingUp,
      title: "Immediate Results",
      description: "Start saving time and increasing productivity from day one with actionable AI techniques.",
      highlight: "Results in 24 hours"
    },
    {
      icon: FiShield,
      title: "Lifetime Access",
      description: "Keep up with AI updates forever. Course materials updated quarterly at no extra cost.",
      highlight: "Never pay again"
    },
    {
      icon: FiBookOpen,
      title: "Easy Learning",
      description: "No tech jargon or complex setup. Simple, step-by-step instructions that anyone can follow.",
      highlight: "Zero technical background needed"
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-white dark:bg-slate-900">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 xl:px-16">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-bold text-slate-800 dark:text-white mb-6">
            Why GenXDojo Works for <span className="text-amber-500">You</span>
          </h2>
          <p className="text-2xl md:text-3xl text-slate-600 dark:text-slate-300 max-w-4xl mx-auto font-medium leading-relaxed">
            Finally, AI training that respects your time, intelligence, and real-world needs.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              transition={{duration: 0.6,delay: index * 0.1}}
              viewport={{once: true}}
              className="bg-gradient-to-br from-slate-50 to-white dark:from-slate-800 dark:to-slate-700 p-8 rounded-2xl hover:shadow-2xl dark:hover:shadow-3xl transition-all duration-300 border-2 border-transparent hover:border-amber-200 dark:hover:border-amber-600"
            >
              <div className="flex items-center mb-6">
                <div className="bg-gradient-to-r from-amber-100 to-amber-200 dark:from-amber-900/50 dark:to-amber-800/50 p-4 rounded-xl mr-4 border-2 border-amber-300 dark:border-amber-600">
                  <SafeIcon icon={benefit.icon} className="w-8 h-8 text-amber-600 dark:text-amber-400" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-800 dark:text-white mb-2">{benefit.title}</h3>
                  <div className="bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400 px-3 py-1 rounded-full text-sm font-bold">
                    {benefit.highlight}
                  </div>
                </div>
              </div>
              <p className="text-lg text-slate-700 dark:text-slate-200 leading-relaxed font-medium">{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;